import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import React from 'react';

import {
  ProteinBlastColoringSchemes,
  ColoringSchemeType,
  getResidueColorStyle,
} from 'search/blast/ColoringScheme';

export interface ProteinColoringSchemeOptionProps {
  coloringScheme: ColoringSchemeType;
}

const EXAMPLE_RESIDUES: Array<string> = ['A', 'C', 'D', 'F'];
const MISMATCH_INDEX = 2;

export function ProteinColoringSchemeOption({coloringScheme}: ProteinColoringSchemeOptionProps): JSX.Element {
  return (
    <div className={classNames('u-lr-split', css(styles.optionContainer))}>
      <div>{ProteinBlastColoringSchemes[coloringScheme].name}</div>
      <div>
        {EXAMPLE_RESIDUES.map((residue, index) => (
          <span
            key={residue}
            className={css(styles.residue)}
            style={getResidueColorStyle(coloringScheme, residue, index === MISMATCH_INDEX)}
          >
            {residue}
          </span>
        ))}
      </div>
    </div>
  );
}

const styles = StyleSheet.create({
  optionContainer: {
    gap: '20px',
  },
  residue: {
    paddingLeft: '2px',
    paddingRight: '2px',
  },
});
